import { connect } from 'react-redux'
import ProductInfo from '../../../components/products/details/product/details/pane/ProductInfo'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    product: ownProps.product
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductInfo)



// WEBPACK FOOTER //
// ./src/containers/products/productdetail/ProductInfo.ts